import { render } from "./MyCourseIcon.vue?vue&type=template&id=83add848"
import script from "./MyCourseIcon.vue?vue&type=script&lang=js"
export * from "./MyCourseIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__